// src/services/schoolService.jsx
import http from "./http";

/* --------------------------------
   ADD SCHOOL
   POST /api/schools?action=add
-------------------------------- */
export const addSchool = async (payload) => {
  try {
    const res = await http.post("schools?action=add", {
      name: payload.name,
      schoolId: payload.schoolId,
      loginId: payload.loginId,
      password: payload.password,
      photo_start_number: payload.photo_start_number || 1001,
    });
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   UPDATE SCHOOL
   POST /api/schools?action=update
-------------------------------- */
export const updateSchool = async (id, payload) => {
  try {
    const res = await http.post("schools?action=update", {
      id: id,
      name: payload.name,
      schoolId: payload.schoolId,
      loginId: payload.loginId,
      password: payload.password,
      photo_start_number: payload.photo_start_number,
    });
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   GET ALL SCHOOLS
   POST /api/schools?action=get
-------------------------------- */
export const getSchools = async () => {
  try {
    const res = await http.post("schools?action=get");
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   GET SINGLE SCHOOL
   POST /api/schools?action=get&id=...
-------------------------------- */
export const getSchoolById = async (id) => {
  try {
    const res = await http.post(`schools?action=get&id=${id}`);
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   DELETE SCHOOL
   POST /api/schools?action=delete
-------------------------------- */
export const deleteSchool = async (id) => {
  try {
    const res = await http.post("schools?action=delete", {
      id: id,
    });
    return res.data;
  } catch (error) {
    return { status: "error", message: "Network Error: Could not connect to server" };
  }
};

/* --------------------------------
   SCHOOL TIMINGS
-------------------------------- */
export const getSchoolTimings = async () => {
  try {
    const res = await http.get("school_timings");
    return res.data;
  } catch (error) {
    return error?.response?.data || { status: false, message: "Network Error" };
  }
};

export const saveSchoolTimings = async (payload) => {
  try {
    const res = await http.post("school_timings", payload, {
      headers: { "Content-Type": "application/json" }
    });
    return res.data;
  } catch (error) {
    return error?.response?.data || { status: false, message: "Network Error" };
  }
};

export const getAttendanceReports = async (params = {}) => {
  try {
    const res = await http.get("attendance_reports", { params });
    return res.data;
  } catch (error) {
    return error?.response?.data || { status: false, message: "Network Error" };
  }
};

/* --------------------------------
   EXPORT ATTENDANCE REPORT (JSON)
   GET /api/school/export_attendance_report
   Returns JSON with download_url
-------------------------------- */
export const exportAttendanceReport = async (params = {}) => {
  try {
    const res = await http.get("export_attendance_report", { params });
    return res.data;
  } catch (error) {
    return error?.response?.data || { status: false, message: "Export failed" };
  }
};

